import { gql } from '@apollo/client';

export const QUERY_MUNICIPALITY_PAGE = gql`
  query MunicipalityPage($code: String!, $language: String) {
    municipalityPageByCode(municipality_code: $code, language: $language) {
      municipality {
        area_km2
        municipality_code
        name_municipality
        code_uf
        name_uf
        name_region
        biome
        biomes {
          id
          municipality_code
          biome
        }
        classification_type
        density_demographic
        municipality_score {
          general_score_risk
          general_score_opportunity
          classification_risk
          classification_opportunity
        }
        population
      }
      dimensions {
        score_risk
        score_opportunity
        classification_risk
        classification_opportunity
        dimension {
          bigquery_id
          id
          name
          icon
          order
          description
        }
      }
    }
  }
`;

export const QUERY_MUNICIPALITY_COMPARATIVE = gql`
  query MunicipalityComparative(
    $municipalityCode: String!
    $dimensionId: Float
    $language: String
  ) {
    municipalityComparative(
      municipalityCode: $municipalityCode
      dimension_id: $dimensionId
      language: $language
    ) {
      dimension {
        id
        name
        tooltip
        order
        bigquery_id
      }
      state_average_opportunity
      classification_opportunity
      classification_risk
      state_average_risk
      municipality_opportunity
      municipality_risk
      municipality {
        name_uf
        name_municipality
        municipality_code
      }
      intensity_color_opportunity
      intensity_color_risk
    }
  }
`;

export const QUERY_MUNICIPALITY_DIMENSION_HIGHLIGHTS = gql`
  query MunicipalityDimensionHighlights($municipalityCode: String!, $language: String!) {
    municipalityDimensionHighlights(municipalityCode: $municipalityCode, language: $language) {
      highlights {
        topOpportunities {
          classification
          dimension {
            id
            name
          }
          score
        }
        topRisks {
          classification
          dimension {
            id
            name
          }
          score
        }
      }
    }
  }
`;

export const QUERY_MUNICIPALITIES_WITH_SEARCH = gql`
  query GetAllMunicipalitiesWithSearch($search: String, $page: Float, $limit: Float) {
    getAllMunicipalitiesWithSearch(search: $search, page: $page, limit: $limit) {
      data {
        municipality_code
        name_municipality
        display_name
      }
      total
    }
  }
`;

export const QUERY_MUNICIPALITIES_COMPARATIVE = gql`
  query MunicipalitiesComparative(
    $municipalitiesCodes: [String!]!
    $dimensionId: Float
    $language: String
  ) {
    municipalitiesComparative(
      municipalities_codes: $municipalitiesCodes
      dimension_id: $dimensionId
      language: $language
    ) {
      municipality {
        id
        municipality_code
        name_municipality
        code_uf
        density_demographic
        name_uf
        sigla_uf
        code_region
        name_region
        sigla_region
        code_concur
        name_concur
        area_km2
        biome
        classification_type
        population
        state {
          id
          code_uf
          name_uf
          sigla_uf
          name_region
        }
      }
      classification {
        opportunity
        risk
      }
      score {
        opportunity
        risk
      }
      dimensions {
        dimension {
          id
          name
          icon
          description
          tooltip
          bigquery_id
          order
          created_at
          updated_at
        }
        municipality_opportunity
        municipality_risk
        state_average_opportunity
        state_average_risk
        intensity_color_opportunity
        intensity_color_risk
        classification_opportunity
        classification_risk
      }
    }
  }
`;

export const QUERY_MUNICIPALITY_SCORE_MAP = gql`
  query GetMunicipalityScoreMap(
    $type: String!
    $channel: String!
    $dynamicFilters: [DynamicFilter!]
    $dimensionLevelFilters: [DimensionLevelFilter!]
    $language: String
  ) {
    municipalityScoreMap(
      filters: {
        type: $type
        channel: $channel
        dynamicFilters: $dynamicFilters
        dimensionLevelFilters: $dimensionLevelFilters
      }
      language: $language
    )
  }
`;

export const QUERY_MUNICIPALITY_SCORES_DETAILED = gql`
  query MunicipalityScoresDetailed(
    $municipality_code: String!
    $type: String!
    $bigquery_id: String!
    $language: String
  ) {
    municipalityScoresDetailed(
      municipality_code: $municipality_code
      type: $type
      bigquery_id: $bigquery_id
      language: $language
    ) {
      municipality_code
      name_municipality
      name_region
      biome
      classification_type
      population
      score
      classification
      code_uf
      name_uf
      sigla_uf
    }
  }
`;
